import type { ReactNode } from 'react';
import React from 'react';
import TwoColumnSection from './TwoColumnSection';
import * as styles from '../css/text-with-image-section.css';
import { classNames } from '../utils';

type TextWithImageAlignment = 'image-left' | 'image-right';

export interface Props {
    text: ReactNode;
    image: ReactNode;
    alignment: TextWithImageAlignment;
    first?: boolean;
    last?: boolean;
    imageClassName?: string;
    followedByDetailsText?: boolean;
    introductorySection?: boolean;
}

const TextWithImageSection: React.FC<Props> = ({
    text,
    image,
    alignment,
    first,
    last,
    imageClassName,
    ...rest
}) => {
    const sectionAlignment = alignment === 'image-left' ? 'first-left' : 'first-right';
    return (
        <>
            {!first && alignment === 'image-left' && (
                <div className={styles.polygonTopSlope} />
            )}
            <TwoColumnSection
                first={text}
                second={image}
                className={classNames(alignment === 'image-left' && styles.backgroundGray)}
                alignment={sectionAlignment}
                secondClassName={classNames(styles.image, imageClassName)}
                {...rest}
            />
            {!last && alignment === 'image-left' && (
                <div className={styles.polygonBottomSlope} />
            )}
        </>
    );
};

export default TextWithImageSection;
